/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import { Helmet } from 'react-helmet'
import '../style/myvideo.css'
import gs1 from '../images/gs-1.jpg'
import gs2 from '../images/gs-2.jpg'
import gs3 from '../images/gs-3.jpg'
import hb1 from '../images/hb-1.jpg'
import hb2 from '../images/hb-2.jpg'
import hb3 from '../images/hb-3.jpg'
import ss1 from '../images/ss-1.jpg'
import ss2 from '../images/ss-2.jpg'
import ss3 from '../images/ss-3.jpg'

const MyViedo = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Umang Ratani business consultancy resources offer expert insights and tools to optimize your business growth and management strategies effectively.' />
                <title>Umang Ratani: Expert Business Consultancy Resources</title>
            </Helmet>
            <section id='bgServeNewV'>
                <div className="container" style={{ textAlign: 'center' }} >
                    <h3 id='animath5' style={{ color: "white", paddingTop: "125px", paddingBottom: '175px' }} className="block-sub__title">Video Resources</h3>
                </div>
            </section>
            <section>
                <div className='container' style={{ marginTop: '50px' }}>
                    <h3 style={{ textAlign: 'center', color: '#00415d' }}>Goal Setting Workshop</h3>
                    <div className='row' style={{ marginTop: '50px' }}>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a  href="https://www.youtube.com/watch?v=fT9FgRJwMWQ&t=4s">
                                <img src={gs1} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>How To Achieve All Your Goals</h5>
                        </div>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://www.youtube.com/watch?v=PA81iEQAOD0">
                                <img src={gs2} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>OKRs – Right way to set your Goals</h5>
                        </div>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://www.youtube.com/watch?v=N9At20uIKRA">
                                <img src={gs3} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>Right Way to Set Goals and Achieve them</h5>
                        </div>
                    </div>
                </div>
                <div className='container' style={{ marginTop: '50px' }}>
                    <h3 style={{ textAlign: 'center', color: '#00415d' }}>Habit Mastery Workshop</h3>
                    <div className='row' style={{ marginTop: '50px' }}>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://youtu.be/cVG7ZbcHzfM">
                                <img src={hb1} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>Habits Mastery</h5>
                        </div>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://youtu.be/2ahkxNqdOWs">
                                <img src={hb2} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>Your Habits shapes your Identity</h5>
                        </div>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://youtu.be/R1C921bKBeE">
                                <img src={hb3} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>How to build Better Habits</h5>
                        </div>
                    </div>
                </div>
                <div className='container' style={{ marginTop: '50px' }}>
                    <h3 style={{ textAlign: 'center', color: '#00415d' }}>Success Summit Workshop</h3>
                    <div className='row' style={{ marginTop: '50px' }}>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://youtu.be/dJ0TgpLbM4g">
                                <img src={ss1} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>Success Summit with Parikhsit Jobanputra</h5>
                        </div>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://youtu.be/KAI2ovX6Koc">
                                <img src={ss2} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>Success Summit with Jack Butcher</h5>
                        </div>
                        <div className='col-sm' style={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                            <a href="https://youtu.be/H6SGhqGfxZ8">
                                <img src={ss3} alt="image" id='imgV' />
                                <img
                                    src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/play-141.png"
                                    alt="play button"
                                    style={{ position: 'absolute', top: '30%', left: '40%', transform: 'translate(-30%, -40%)', width: '80px', height: '80px' }}
                                />
                            </a>
                            <h5 style={{ marginTop: '25px' }}>Success Summit with Shivani Bose</h5>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MyViedo
